import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AgentDto } from '../../../../service/dto';
import { Callback } from '../../login.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../../service/auth.service';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
	selector: 'app-login-form',
	standalone: false,
	templateUrl: './login-form.component.html',
	styleUrl: './login-form.component.scss'
})
export class LoginFormComponent {
	@Input() agent!: AgentDto;
	@Output("doUpdateState") doUpdateState = new EventEmitter<Callback>();

	loginForm: FormGroup;
	showPassword = false;

	constructor(private fb: FormBuilder, private authService: AuthService, private modalService:NzModalService) {
		this.loginForm = this.fb.group({
			username: ['', Validators.required],
			password: ['', Validators.required],
		});
	}

	togglePasswordVisibility(): void {
		this.showPassword = !this.showPassword;
	}

	onSubmit(): void {
		if (this.loginForm.valid) {
			const username = this.loginForm.get('username')!.value;
			const password = this.loginForm.get('password')!.value;

			this.authService.doCheckUsernameAndPassword(username, password)
			.subscribe(result => {
				if(result.success === false){
					this.modalService.error({
						nzTitle: 'Login Failed',
						nzContent: result.message || 'Invalid username or password',
						nzOkText: 'OK',
						nzCentered: true
					});
				} else {
					// Password is correct, move to 2FA and pass credentials in memory
					this.doUpdateState.emit({
						mode: 'TwoFactorAuth',
						agent: result.agent,
						credentials: { username: username, password: password }
					});
				}
			});
		}
		// if (this.loginForm.valid) {
		// 	this.authService.doAuthenticate(this.loginForm.get('username')!.value, this.loginForm.get('password')!.value, '')
		// 	.subscribe(result => {
		// 		if(result.success==false){
		// 			this.modalService.error({
		// 				nzTitle: 'Login Failed',
		// 				nzContent: result.message || 'Invalid username or password',
		// 				nzOkText: 'OK',
		// 				nzCentered: true
		// 			});
		// 		}
		// 	})
		// }
	}
	doForgotPassword(){
		this.doUpdateState.emit({mode: 'ForgotPassword'})
	}
}
